import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import BackToTop from "./pages/BackToTop";
import PaperImage from "./components/PaperImage";
import Footer from "./pages/Footer";

import Information from "./pages/Information";
// import InputFormValidate from "./pages/InputFormValidate";
// import Done from "./pages/Done";
import { useAppSelector } from "./app/hooks";

// AWS
import Amplify from "aws-amplify";

const theme = createTheme({
  palette: {
    primary: {
      // H-IXテーマカラー (1)
      main: "#43070e",
    },
    secondary: {
      // H-IXテーマカラー (2)
      main: "#f4f0e5",
    },
  },
});

// AWS Amplify
Amplify.configure({
  API: {
    endpoints: [
      {
        name: "store",
        endpoint: `${process.env.REACT_APP_ENDPOINT}`,
      },
    ],
  },
});

function App() {
  const pagenoValue: number = useAppSelector((state) => state.inputform.pageno);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* ヘッダー */}
        <BackToTop />

        {/* 画像部分 */}
        <PaperImage title={"VIRTUAL TOUR"} subtitle={"バーチャル見学"} image="./hix_lobby.jpg" />

        {/* 見学のご案内ページ */}
        {`${pagenoValue}` === "1" ? <Information /> : <React.Fragment></React.Fragment>}
        {/* 入力画面 */}
        {/* {`${pagenoValue}` === "2" ? <InputFormValidate /> : <React.Fragment></React.Fragment>} */}
        {/* 送信後画面 */}
        {/* {`${pagenoValue}` === "3" ? <Done /> : <React.Fragment></React.Fragment>} */}

        {/* フッター */}
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
